import React from "react";
import { Grid } from "@mui/material";
import MultiFileSummary from "../../../Files/MultiFileSummary";
import { Panel } from "@poseidon/ui/components/Panel";

export const FileManagementSection = ({ application }) => (
  <Panel expandable title="Application WIP">
    <Grid container spacing={2} mt={0}>
      <Grid item xs={12} sm={6}>
        <MultiFileSummary
          link={`/sailors/${application.applicant.sailor.id}/supportingDocumentation/files`}
          actionRef={`/sailors/${application.applicant.sailor.id}/actions/supportingDocumentation`}
          fieldLabel="Supporting Documentation"
        />
      </Grid>

      {application.isJoint && (
        <Grid item xs={12} sm={6}>
          <MultiFileSummary
            link={`/sailors/${application.jointApplicant.sailor.id}/supportingDocumentation/files`}
            docRef={`/sailors/${application.jointApplicant.sailor.id}/actions/supportingDocumentation`}
            fieldLabel="Supporting Documentation (Joint)"
          />
        </Grid>
      )}

      <Grid item xs={12} sm={6}>
        <MultiFileSummary
          link={`/applications/${application.id}/invoices/files`}
          actionRef={`/applications/${application.id}/actions/invoices`}
          fieldLabel="Invoice documents"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MultiFileSummary
          link={`/applications/${application.id}/insurance/files`}
          actionRef={`/applications/${application.id}/actions/insurance`}
          fieldLabel="Insurance documents"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MultiFileSummary
          link={`/applications/${application.id}/survey/files`}
          actionRef={`/applications/${application.id}/actions/survey`}
          fieldLabel="Survey documents"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MultiFileSummary
          link={`/applications/${application.id}/loanDocs/files`}
          actionRef={`/applications/${application.id}/actions/loanDocs`}
          fieldLabel="Loan And Mortgage documents"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MultiFileSummary
          link={
            application.vessel
              ? `/boats/${application.vessel.id}#boatDocumentation`
              : null
          }
          actionRef={`/applications/${application.id}/actions/boatDocumentation`}
          fieldLabel="Boat Documentation"
        />
      </Grid>
    </Grid>
  </Panel>
);
